// 工单模块路由配置
export const ticketMain = [
  {
    name: 'ticket',
    path: '/ticket',
    meta: {
      title: '工单管理',
      icon: 'el-icon-tickets'
    }
  },
  {
    name: 'ticketList',
    path: '/ticket/list',
    icon: 'el-icon-tickets',
    component: () => import('/@/views/plugins/ticket/List.vue'),
    meta: {
      title: '工单列表',
      icon: 'el-icon-tickets',
      plugin: 'ticket',
      keepAlive: true
    }
  },
  {
    name: 'ticketDetail',
    path: '/ticket/detail/:id',
    icon: 'el-icon-tickets',
    component: () => import('/@/views/plugins/ticket/Detail.vue'),
    meta: {
      title: '工单详情',
      icon: 'el-icon-tickets',
      plugin: 'ticket',
      activeMenu: '/ticket'
    }
  },
  {
    name: 'ticketCategory',
    path: '/ticket/category',
    icon: 'el-icon-tickets',
    component: () => import('/@/views/plugins/ticket/Category.vue'),
    meta: {
      title: '工单分类',
      icon: 'el-icon-tickets',
      plugin: 'ticket'
    }
  }
]

export default ticketMain
